import React from 'react';

export const GoldContent = (): JSX.Element => {
  return (
    <div className="py-4">
      <div className="text-s-28 font-bold sm:text-s-20">
        Gold System in India
      </div>
      <div className="py-5">
        <p className="text-base">
          Indians have a long and strong history of trading and investing in
          gold. Gold is a precious commodity and a good investment option for
          consumers looking at steady and long term returns from their
          investment. Gold prices fluctuate often, based on a wide range of
          factors such as seasonal demand in the country, current strength of
          the US Dollar etc.
        </p>
        <ol>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              1. Gold Rate in India
            </strong>{' '}
            <br />
            India is home to small and large scale gold dealers. These dealers
            exclusively deal with gold in ornament and solid form. Many factors
            related to national and international market trends decide the gold
            rates in India. People usually buy it in the form of coins, ingots,
            jewelry and ornaments or demat format.{' '}
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              2. How to invest in Gold?
            </strong>
            <br />
            One can invest in gold through multiple ways, here&apos;s how:
            Buying Jewellery - The age-old traditional method of investing in
            gold is in the form of jewellery or ornaments. However, today people
            also go for other options like bars, coins or demat forms (Gold
            Sovereign Bonds or Gold ETFs) if they want to save on making
            charges.
            <br />
            Investment in Gold Coins and/or Bars - As compared to jewellery, an
            investment in gold coins and bars are better as you can save on any
            making charges that would otherwise be applicable. You should always
            buy gold bars and coins only from reputed jewelers or from banks.
            <br />
            Gold ETF: Gold Exchange Traded Fund is a type of mutual fund which
            invests in gold and the units of this mutual fund scheme are listed
            in the stock exchange.
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              3. How to sell Gold in India?
            </strong>{' '}
            <br />
            Gold, being highly liquid in nature, can be easily and instantly
            redeemed for cash, whether you choose to sell it or pledge it. In
            fact, if you sell your gold at the same shop where you bought it
            from (please keep the bill/invoice with you), it will avoid any
            suspicion regarding purity of the commodity and ensure a smoother
            transaction.
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              4. Factors Affecting Gold Price in India
            </strong>{' '}
            <br />
            There are many factors that affect the prices of gold, both
            domestically and internationally. Here are a few: Inflation: holds
            significant value to offset inflation during market fluctuations.
            Hence, the demand for gold increases resulting in price hikes. This
            holds good domestic and international inflation. <br />
            Government Gold Reserves: RBI, like Central Banks of many countries,
            holds both currency and gold reserves as every rupee must be backed
            up by gold. An increase in their gold reserves indicates increased
            inflow of cash in the market, which in turn affects the pricing of
            gold. <br />
            Jewelry Market: Gold jewelry and ornaments are inevitable part of
            Indian fashion sensibilities, which contribute to its increasing
            demand and supply, especially during festive and wedding seasons.
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              5. Measurement of Gold{' '}
            </strong>
            <br />
            The weight of gold is measured in troy ounces (1 troy ounce =
            31.1034768 grams), while Karat represents the purity of gold
            Following is the fineness scale which is used while defining the
            purity of gold: <br />
            24 K = 99.9% Pure <br />
            22 K = 91.6% Pure <br />
            18 K = 75% Pure
          </li>
        </ol>
      </div>
    </div>
  );
};
